import { css } from '@emotion/react';

const exerciseStyle = ({ isTpdCourse }) => css`
  /* Exercise-specific styles */
  ${isTpdCourse &&
  `
    font-family: 'Atkinson Hyperlegible', sans-serif !important;

    /* Apply to all elements within exercise pages */
    h1,
    h2,
    h3,
    h4,
    h5,
    h6,
    p,
    a,
    span,
    div {
      font-family: 'Atkinson Hyperlegible', sans-serif !important;
    }
  `}
`;

export default exerciseStyle;
